import { render, staticRenderFns } from "./EventGroupShow.vue?vue&type=template&id=0d8b22d4&scoped=true"
import script from "./EventGroupShow.vue?vue&type=script&lang=js"
export * from "./EventGroupShow.vue?vue&type=script&lang=js"
import style0 from "./EventGroupShow.vue?vue&type=style&index=0&id=0d8b22d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8b22d4",
  null
  
)

export default component.exports